// src/components/NewLaskurahoitus.js
import React from 'react';
import { Helmet } from 'react-helmet';
import {
    Box,
    Typography,
    Button,
    Grid,
    Container,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { CheckCircle as CheckCircleIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import theme from './theme';
import heroImage from './assets/hero-image-digital-finance.jpg'; // Ensure this path is correct
// import factoringIllustration from './assets/factoring-illustration.jpg'; // Ensure this path is correct

// Styled component for the image section with dark overlay
const ImageSection = styled(Box)(({ theme }) => ({
    position: 'relative',
    height: '30vh', // 30% of viewport height
    backgroundImage: `url(${heroImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(2),
    // Adding the dark overlay using a pseudo-element
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 50% black
        zIndex: 1,
    },
    // Ensuring that the child elements are above the overlay
    '& > *': {
        position: 'relative',
        zIndex: 2,
    },
}));

function NewLaskurahoitus() {
    return (
        <>
            <Helmet>
                <title>Laskurahoitus Factoring Vertailu ja Kilpailutus | Rahoituskanava</title>
                <meta
                    name="description"
                    content="Kilpailutamme laskurahoituspalvelut ja löydät yritykselle parhaan factoring-ratkaisun nopeasti. Saat monta tarjousta yhdellä hakemuksella."
                />
                <meta
                    name="keywords"
                    content="yritysrahoitus, laskurahoitus, factoring, kilpailutus, Rahoituskanava"
                />
            </Helmet>

            {/* Image Section */}
            <ImageSection>
                <Box>
                    <Typography variant="h2" component="h1" gutterBottom sx={{ color: 'white' }}>
                        Laskurahoitus eli Factoring
                    </Typography>
                    <Typography variant="h5" sx={{ color: 'white' }}>
                        Muuta yrityksesi myyntilaskut rahaksi ennen eräpäivää
                    </Typography>
                </Box>
            </ImageSection>

            {/* Main Content Container */}
            <Container maxWidth="lg" sx={{ paddingY: 4 }}>
                <Grid container spacing={4}>
                    {/* Information Section */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="h3" gutterBottom>
                            Mikä on Laskurahoitus?
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Laskurahoitus, eli factoring, on rahoitusratkaisu, jossa yrityksesi myyntisaatavat muutetaan
                            rahaksi ennen niiden eräpäivää. Tämä parantaa kassavirtaasi ja mahdollistaa yrityksen
                            kasvun ilman pitkiä maksuaikoja.
                        </Typography>
                        <List>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="Kilpailuttamalla saat tarjouksia useilta factoring-yhtiöiltä" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="Palvelu on maksutonta eikä sitoudu mihinkään tarjouksia pyytäessäsi" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleIcon color="primary" />
                                </ListItemIcon>
                                <ListItemText primary="Rahoita yksi tai useampi myyntilaskusi joustavasti" />
                            </ListItem>
                        </List>
                        <Button
                            variant="contained"
                            component={RouterLink}
                            to="/laskurahoitus/hakemus"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                                mt: 2,
                                backgroundColor: 'primary.main',
                                color: 'primary.contrastText',
                                fontWeight: 300,
                                padding: '10px 20px',
                                borderRadius: '10px',
                                '&:hover': {
                                    backgroundColor: 'secondary.main',
                                },
                            }}
                            aria-label="Hae laskurahoitusta"
                        >
                            Hae Laskurahoitusta
                        </Button>
                    </Grid>

                    {/* Image or Illustration */}
                    <Grid item xs={12} md={6}>

                        {/*
                        <Box
                            component="img"
                            src={factoringIllustration}
                            alt="Factoring Illustration"
                            sx={{ width: '100%', borderRadius: '10px' }}
                        /> */}
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export default NewLaskurahoitus;
